"use strict";
var $dyn;
(function ($dyn) {
    var messaging;
    (function (messaging) {
        /**
         * Framework class for Notification data
         */
        var Notification = /** @class */ (function () {
            function Notification() {
                var _this = this;
                this.text = "";
                this.state = $dyn.messaging.State.active;
                this.severity = $dyn.messaging.Severity.information;
                this.originType = $dyn.messaging.OriginType.Alert;
                this.createdDateTime = moment.tz("User");
                this.notificationActions = [];
                this.statusIcon = $dyn.computed(function () {
                    if (_this.severity === $dyn.messaging.Severity.information) {
                        return "information";
                    }
                    else if (_this.severity === $dyn.messaging.Severity.warning) {
                        return "warning";
                    }
                    else {
                        return "error";
                    }
                });
                this.stateMessage = $dyn.computed(function () {
                    switch (_this.state) {
                        case $dyn.messaging.State.completed:
                            return $dyn.label("MessageCenter_StatusCompleted");
                        case $dyn.messaging.State.expired:
                            return $dyn.label("MessageCenter_StatusExpired");
                        case $dyn.messaging.State.active:
                        default:
                            return $dyn.label("MessageCenter_StatusActive");
                    }
                });
                this.isAlert = $dyn.computed(function () {
                    return _this.originType === $dyn.messaging.OriginType.Alert;
                });
                this.isWatchDog = $dyn.computed(function () {
                    return _this.originType === $dyn.messaging.OriginType.WatchDog;
                });
                this.showLink = $dyn.computed(function () {
                    return _this.notificationActions.length > 0;
                });
                this.formattedCreatedTimeStamp = $dyn.computed(function () {
                    if (_this.createdDateTime) {
                        return moment.tz(_this.createdDateTime, "User").fromNow();
                    }
                    else if (_this.timeStampMomentUtc) {
                        return _this.timeStampMomentUtc.fromNow();
                    }
                    else {
                        return null;
                    }
                });
            }
            return Notification;
        }());
        messaging.Notification = Notification;
    })(messaging = $dyn.messaging || ($dyn.messaging = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Notification.js.map
